(function () {
  'use strict';

  var ADD_TIMEOUT_MS = 15000;

  function swapMainImage(src, alt) {
    if (!src) return;
    var mainImg = document.querySelector('[data-pdp-main-img]');
    if (mainImg) {
      mainImg.style.opacity = '0';
      mainImg.style.transform = 'scale(0.97)';
      setTimeout(function () {
        mainImg.src = src;
        if (alt) mainImg.alt = alt;
        mainImg.style.opacity = '1';
        mainImg.style.transform = 'scale(1)';
      }, 160);
      return;
    }

    var productImg = document.querySelector('.product_variant_image, .product__media img, #ProductPhotoImg');
    if (productImg) {
      productImg.src = src;
      if (alt) productImg.alt = alt;
    }
  }

  function syncThumbActive(src) {
    if (!src) return;
    var thumbs = document.querySelectorAll('[data-pdp-thumb]');
    if (!thumbs.length) return;
    var matched = false;
    thumbs.forEach(function (thumb) {
      var isMatch = thumb.dataset.fullSrc === src;
      thumb.classList.toggle('is-active', isMatch);
      if (isMatch) matched = true;
    });
    if (!matched && thumbs[0]) {
      thumbs[0].classList.add('is-active');
    }
  }

  function initVariantPicker() {
    document.querySelectorAll('[data-eride-variant-picker]').forEach(function (picker) {
      if (picker.dataset.bound) return;
      picker.dataset.bound = 'true';

      var form = picker.closest('form');
      var nativeSelect = picker.querySelector('.eride-variant-picker__native');
      var buttons = picker.querySelectorAll('.eride-variant-picker__btn');

      function applyVariant(btn) {
        if (!btn || btn.disabled) return;
        var variantId = btn.dataset.variantId;
        var imageSrc = btn.dataset.variantImage;
        var label = btn.querySelector('.eride-variant-picker__text');
        var alt = label ? label.textContent.trim() : '';

        buttons.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (nativeSelect) {
          nativeSelect.value = variantId;
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (form) {
          var hiddenId = form.querySelector('input[name="id"]:not(.eride-variant-picker__native)');
          if (hiddenId && hiddenId !== nativeSelect) hiddenId.value = variantId;
        }

        var productSelect = document.getElementById('productSelect');
        if (productSelect && productSelect !== nativeSelect) {
          productSelect.value = variantId;
          if (typeof jQuery !== 'undefined') {
            jQuery(productSelect).trigger('change');
          } else {
            productSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        swapMainImage(imageSrc, alt);
        syncThumbActive(imageSrc);
        document.dispatchEvent(new CustomEvent('eride:variant-change', {
          detail: { variantId: parseInt(variantId, 10), image: imageSrc, label: alt }
        }));
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          applyVariant(btn);
        });
      });
    });
  }

  function initPdpGallery() {
    var pdp = document.querySelector('[data-eride-pdp]');
    if (!pdp) return;

    var mainImg = pdp.querySelector('[data-pdp-main-img]');
    var thumbs = pdp.querySelectorAll('[data-pdp-thumb]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.fullSrc;
        if (!src) return;
        mainImg.style.opacity = '0';
        mainImg.style.transform = 'scale(0.97)';
        setTimeout(function () {
          mainImg.src = src;
          mainImg.style.opacity = '1';
          mainImg.style.transform = 'scale(1)';
        }, 180);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  function getMinOrderQty(form) {
    var tierWidget = document.getElementById('eride-tier-widget');
    if (!tierWidget) return 1;
    var qtyInput = tierWidget.querySelector('.eride-pricing__qty-input');
    var min = qtyInput && qtyInput.min ? parseInt(qtyInput.min, 10) : 1;
    return min > 0 ? min : 1;
  }

  function syncFormBeforeAdd(form) {
    var minQty = getMinOrderQty(form);
    var qtyInput = form.querySelector('.eride-pricing__qty-input');
    var formQty = form.querySelector('[data-eride-form-qty]');
    if (qtyInput && formQty) {
      formQty.value = Math.max(minQty, parseInt(qtyInput.value, 10) || minQty);
    }
    if (qtyInput) {
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    document.dispatchEvent(new CustomEvent('eride:pre-add-to-cart'));
  }

  function collectPayload(form) {
    syncFormBeforeAdd(form);

    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput ? parseInt(idInput.value, 10) : 0;
    var qtyEl = form.querySelector('[data-eride-form-qty]') || form.querySelector('[name="quantity"]');
    var minQty = getMinOrderQty(form);
    var quantity = Math.max(minQty, parseInt(qtyEl && qtyEl.value, 10) || minQty);
    var properties = {};

    form.querySelectorAll('input[name^="properties["], textarea[name^="properties["]').forEach(function (input) {
      var match = input.name.match(/^properties\[(.+)\]$/);
      if (match && input.value !== '') {
        properties[match[1]] = input.value;
      }
    });

    return { id: variantId, quantity: quantity, properties: properties };
  }

  function bumpBadge(qty) {
    document.querySelectorAll('.bigcounter, .count-style').forEach(function (el) {
      var n = parseInt(el.textContent, 10) || 0;
      el.textContent = n + qty;
    });
  }

  function setButtonState(btn, state, defaultLabel) {
    btn.classList.toggle('is-loading', state === 'loading');
    if (state === 'loading') {
      btn.textContent = 'Adding…';
      btn.disabled = true;
    } else if (state === 'success') {
      btn.textContent = 'Added ✓';
      btn.disabled = false;
      setTimeout(function () { btn.textContent = defaultLabel; }, 2000);
    } else {
      btn.textContent = defaultLabel;
      btn.disabled = false;
    }
  }

  function finishCartUi() {
    if (window.ErideCart) {
      if (typeof window.ErideCart.setLoading === 'function') {
        window.ErideCart.setLoading(false);
      }
      if (typeof window.ErideCart.refresh === 'function') {
        return window.ErideCart.refresh().then(function () {
          window.ErideCart.open();
        }).catch(function () {
          window.ErideCart.open();
        });
      }
      window.ErideCart.open();
    } else if (typeof Shopify !== 'undefined' && typeof Shopify.getCart === 'function') {
      Shopify.getCart();
    }
    return Promise.resolve();
  }

  function addToCart(form, btn, defaultLabel) {
    var payload = collectPayload(form);

    if (!payload.id) {
      alert('Please select a product variant.');
      return;
    }

    setButtonState(btn, 'loading', defaultLabel);

    if (window.ErideCart) {
      window.ErideCart.open();
      if (typeof window.ErideCart.setLoading === 'function') {
        window.ErideCart.setLoading(true);
      }
    }

    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, ADD_TIMEOUT_MS);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      signal: controller.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        clearTimeout(timeoutId);
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        bumpBadge(payload.quantity);
        setButtonState(btn, 'success', defaultLabel);
        return finishCartUi();
      })
      .catch(function (err) {
        clearTimeout(timeoutId);
        setButtonState(btn, 'idle', defaultLabel);
        if (window.ErideCart && typeof window.ErideCart.setLoading === 'function') {
          window.ErideCart.setLoading(false);
        }
        var msg = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
        if (err && err.name === 'AbortError') {
          msg = 'Request timed out. Check your connection and try again.';
        }
        alert(msg);
      });
  }

  function handleAtcClick(e) {
    var btn = e.target.closest('[data-eride-pdp-atc]');
    if (!btn || btn.disabled) return;

    var form = document.getElementById('ErideVehicleForm');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    var defaultLabel = btn.dataset.defaultLabel || btn.textContent.trim();
    if (!btn.dataset.defaultLabel) btn.dataset.defaultLabel = defaultLabel;

    addToCart(form, btn, defaultLabel);
  }

  function initPdpAtc() {
    document.addEventListener('click', handleAtcClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVariantPicker();
      initPdpGallery();
      initPdpAtc();
    });
  } else {
    initVariantPicker();
    initPdpGallery();
    initPdpAtc();
  }
})();
